import { render, staticRenderFns } from "./FormItem.vue?vue&type=template&id=50341493&"
import script from "./FormItem.js?vue&type=script&lang=js&"
export * from "./FormItem.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/develop.mijnmooiestraat.vlaanderen/pro-develop.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50341493')) {
      api.createRecord('50341493', component.options)
    } else {
      api.reload('50341493', component.options)
    }
    module.hot.accept("./FormItem.vue?vue&type=template&id=50341493&", function () {
      api.rerender('50341493', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/FormItem/FormItem.vue"
export default component.exports